import React from "react";
import CssClasses from "./CheckboxGroup.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

const CheckboxGroup = props => {
  let classNames = [CssClasses.btn];

  let btnName =
    props.type === "check"
      ? SiteIcons.site_icon_checkbox_checked
      : props.type === "uncheck"
        ? SiteIcons.site_icon_checkbox_unchecked
        : props.type === "remove"
          ? SiteIcons.site_icon_checkbox_delete
          : null;

  classNames.push(btnName);

  return (
    <div className={CssClasses.container} onClick={props.onClick}>
      <span className={classNames.join(" ")} />
      <span className={classNames.join(" ")} />
    </div>
  );
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/Components/UI/CheckboxGroup/CheckboxGroup.js